import { Component } from '@angular/core';
import {NavigationCancel, NavigationEnd, NavigationError, NavigationStart, Router, RouterEvent} from '@angular/router';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  loading = true;
  constructor(private  router: Router) {
    router.events.subscribe((event: RouterEvent) => {
      this.navigationInterceptor(event);
    });
  }
  title = 'dixter-app';

  changeLang(lang: string) {
    switch (lang) {
      case 'pt': {
        localStorage.setItem('LOCAL_DEFAULT_LANGUAGE', 'pt');
        break;
      }
      case 'es': {
        localStorage.setItem('LOCAL_DEFAULT_LANGUAGE', 'es');
        break;
      }
      case 'en': {
        localStorage.setItem('LOCAL_DEFAULT_LANGUAGE', 'en');
        break;
      }
      /*default: {
        this.router.navigateByUrl('/en');
        break;
      }*/
    }
  }

  navigationInterceptor(event: RouterEvent): void {
    if (event instanceof NavigationStart) {
      this.loading = true;
    }
    if (event instanceof NavigationEnd) {
      setTimeout(() => { // here
        this.loading = false;
      }, 2000);
    }

    // Set loading state to false in both of the below events to hide the spinner in case a request fails
    if (event instanceof NavigationCancel) {
      setTimeout(() => { // here
        this.loading = false;
      }, 2000);
    }
    if (event instanceof NavigationError) {
      setTimeout(() => { // here
        this.loading = false;
      }, 2000);
    }
  }
}
